const TFN = '+1 (888) 778-8606';

export const ICELANDAIR = {
  code: 'FI',
  name: 'Icelandair',
  canonical: '/fi/airlines',
  tag: 'Independent Carrier',
  heroGradient: 'from-sky-950 via-blue-900 to-cyan-800',
  accentClass: 'text-cyan-300',
  statColor: 'text-sky-700',
  hubBoxGradient: 'from-sky-900 to-cyan-700',
  ctaGradient: 'from-sky-900 to-cyan-700',
  logo: { src: '/icelandair-logo.svg', alt: 'Icelandair logo' },
  h1First: 'Icelandair Flights',
  h1Second: 'Book at the Best Price',
  subtitle: 'Fly via Reykjavík · Free Multi-Day Stopover in Iceland · 24/7 Expert Support',
  originAirport: 'BOS',
  destinationAirport: 'KEF',
  stats: [
    { value: '1937', label: 'Founded' },
    { value: '30+', label: 'Aircraft' },
    { value: '40+', label: 'Destinations' },
    { value: 'Saga Club', label: 'Loyalty Program' },
  ],
  aboutParagraphs: [
    "Icelandair is Iceland's flag carrier, connecting North America and Europe through its hub at <strong>Reykjavík–Keflavík International Airport (KEF)</strong>. The airline is best known for its free <strong>Icelandair Stopover</strong> program, which lets travelers break up a transatlantic trip with up to seven nights in Iceland at no extra airfare cost.",
    "Operating a fleet of Boeing 737 MAX and 757 aircraft, Icelandair links over 40 destinations across Europe and North America. As an independent carrier outside the major global alliances, it maintains its own <strong>Saga Club</strong> frequent flyer program and codeshare partnerships with airlines including American Airlines and JetBlue.",
  ],
  aboutBullets: [
    'Free multi-day Iceland stopover on transatlantic itineraries',
    'Extensive North America–Europe connecting network via Keflavík',
    'Saga Premium cabin with wider seats and priority service',
    'Saga Club miles redeemable for flights and upgrades',
    'Popular gateway for Northern Lights and Iceland vacation packages',
  ],
  hubs: [
    { code: 'KEF', name: 'Reykjavík–Keflavík' },
    { code: 'BOS', name: 'Boston Logan' },
    { code: 'JFK', name: 'New York JFK' },
    { code: 'ORD', name: 'Chicago O\'Hare' },
    { code: 'IAD', name: 'Washington Dulles' },
    { code: 'SEA', name: 'Seattle-Tacoma' },
  ],
  cabinsHeading: 'Icelandair Cabin Classes',
  cabinsSubheading: 'From Economy to Saga Premium — find the right seat for your Iceland stopover or onward journey.',
  cabins: [
    { name: 'Economy', icon: '💺', color: 'border-sky-200 bg-sky-50', badge: 'bg-sky-100 text-sky-800', features: ['Standard seat pitch', 'Complimentary snack & drink', 'Buy-on-board meal options', 'Free stopover eligibility'] },
    { name: 'Economy Comfort', icon: '🪑', color: 'border-blue-200 bg-blue-50', badge: 'bg-blue-100 text-blue-800', features: ['Extra legroom seating', 'Priority boarding', 'Complimentary meal', 'Dedicated overhead bin space'] },
    { name: 'Saga Premium', icon: '⭐', color: 'border-cyan-200 bg-cyan-50', badge: 'bg-cyan-100 text-cyan-800', features: ['Wider premium seats', 'Priority check-in & security', 'Enhanced dining service', 'Two free checked bags'] },
  ],
  routesHeading: 'Popular Icelandair Routes',
  routesSubheading: 'Frequently booked Icelandair routes — call us for the best available fare and stopover planning.',
  routes: [
    { from: 'Boston (BOS)', to: 'Reykjavík (KEF)', duration: '5h 20m', tag: 'International' },
    { from: 'New York (JFK)', to: 'Reykjavík (KEF)', duration: '5h 40m', tag: 'Popular' },
    { from: 'Reykjavík (KEF)', to: 'London (LHR)', duration: '3h 05m', tag: 'International' },
    { from: 'Reykjavík (KEF)', to: 'Paris (CDG)', duration: '3h 30m', tag: 'International' },
    { from: 'Washington (IAD)', to: 'Reykjavík (KEF)', duration: '5h 55m', tag: 'Deal' },
    { from: 'Seattle (SEA)', to: 'Reykjavík (KEF)', duration: '7h 15m', tag: 'International' },
    { from: 'Reykjavík (KEF)', to: 'Copenhagen (CPH)', duration: '3h 10m', tag: 'International' },
    { from: 'Chicago (ORD)', to: 'Reykjavík (KEF)', duration: '6h 45m', tag: 'Vacation' },
  ],
  ctaHeading: 'Ready to Book Your Icelandair Flight?',
  ctaDesc: 'Our travel experts are available 24/7 to find you the best Icelandair fares, plan your free stopover in Iceland, and assist with any changes.',
  faqs: [
    { q: 'How do I book Icelandair flights through TheAirlineFares?', a: `You can book online at theairlinefares.com or call our 24/7 support line at ${TFN}. Our agents search all available Icelandair fares and can help plan your stopover.` },
    { q: 'What is the Icelandair Stopover program?', a: 'The Stopover program lets you add up to 7 nights in Iceland to your transatlantic itinerary at no extra airfare — a popular way to see the Northern Lights or Golden Circle en route to Europe.' },
    { q: 'What cabin classes does Icelandair offer?', a: 'Icelandair offers Economy, Economy Comfort (extra legroom), and Saga Premium with wider seats and enhanced service.' },
    { q: 'Can I change or cancel my Icelandair ticket?', a: `Change and cancellation rules depend on fare type. Call us at ${TFN} and we will walk you through your options at no extra service charge.` },
    { q: 'What is Icelandair Saga Club?', a: 'Saga Club is Icelandair\'s frequent flyer program. Members earn Saga Points redeemable for flights, upgrades, and stopover packages.' },
  ],
  seoTitle: 'Icelandair Flights – Book Cheap FI Tickets & Stopovers',
  seoDescription: 'Book Icelandair (FI) flights at the lowest fares and plan a free Iceland stopover. Compare Economy, Economy Comfort, and Saga Premium. 24/7 expert support — call +1 (888) 778-8606.',
  seoKeywords: 'Icelandair flights, FI flights, Icelandair booking, Icelandair stopover, cheap Icelandair tickets, Saga Premium, Reykjavik flights, book Icelandair',
  disclaimerName: 'Icelandair',
};

export const LUFTHANSA = {
  code: 'LH',
  name: 'Lufthansa',
  canonical: '/lh/airlines',
  tag: 'Star Alliance Founding Member',
  heroGradient: 'from-indigo-950 via-blue-900 to-indigo-800',
  accentClass: 'text-yellow-300',
  statColor: 'text-indigo-700',
  hubBoxGradient: 'from-indigo-900 to-blue-800',
  ctaGradient: 'from-indigo-900 to-blue-700',
  logo: { src: '/lufthansa-logo.svg', alt: 'Lufthansa logo' },
  h1First: 'Lufthansa Flights',
  h1Second: 'Book at the Best Price',
  subtitle: 'Economy to First Class · Global Star Alliance Network · 24/7 Expert Support',
  originAirport: 'JFK',
  destinationAirport: 'FRA',
  stats: [
    { value: '1953', label: 'Founded' },
    { value: '280+', label: 'Aircraft' },
    { value: '200+', label: 'Destinations' },
    { value: 'Star Alliance', label: 'Global Network' },
  ],
  aboutParagraphs: [
    "Lufthansa is Germany's flag carrier and a founding member of the <strong>Star Alliance</strong>, the world's largest airline alliance. Operating from primary hubs in <strong>Frankfurt (FRA)</strong> and <strong>Munich (MUC)</strong>, Lufthansa connects travelers to over 200 destinations across more than 90 countries.",
    "Part of the Lufthansa Group (which also includes Swiss, Austrian, and Brussels Airlines), the carrier is known for its efficient European hub connectivity and premium long-haul cabins, including its lie-flat <strong>Business Class</strong> and exclusive <strong>First Class</strong> terminal experience in Frankfurt.",
  ],
  aboutBullets: [
    'Star Alliance founding member with 25+ partner airlines',
    'Dedicated First Class Terminal at Frankfurt Airport',
    'Miles & More — one of Europe\'s largest loyalty programs',
    'Extensive short-haul European network via Frankfurt & Munich',
    'Modern long-haul fleet including Airbus A350 and Boeing 747-8',
  ],
  hubs: [
    { code: 'FRA', name: 'Frankfurt' },
    { code: 'MUC', name: 'Munich' },
    { code: 'JFK', name: 'New York JFK' },
    { code: 'ORD', name: 'Chicago O\'Hare' },
    { code: 'IAD', name: 'Washington Dulles' },
    { code: 'LAX', name: 'Los Angeles' },
  ],
  cabinsHeading: 'Lufthansa Cabin Classes',
  cabinsSubheading: 'From Economy to First Class — find the right seat for your journey to Europe and beyond.',
  cabins: [
    { name: 'Economy', icon: '💺', color: 'border-indigo-200 bg-indigo-50', badge: 'bg-indigo-100 text-indigo-800', features: ['Standard seat pitch', 'Complimentary meal service', 'In-seat entertainment', 'Carry-on bag included'] },
    { name: 'Premium Economy', icon: '🪑', color: 'border-blue-200 bg-blue-50', badge: 'bg-blue-100 text-blue-800', features: ['Extra legroom & recline', 'Dedicated check-in', 'Enhanced dining', 'Priority baggage handling'] },
    { name: 'Business Class', icon: '⭐', color: 'border-yellow-200 bg-yellow-50', badge: 'bg-yellow-100 text-yellow-800', features: ['Lie-flat seating on long-haul', 'Lufthansa lounge access', 'Priority boarding', 'Two free checked bags'] },
    { name: 'First Class', icon: '🌟', color: 'border-amber-200 bg-amber-50', badge: 'bg-amber-100 text-amber-800', features: ['Private First Class Terminal (FRA)', 'Chauffeur transfer service', 'Gourmet à la carte dining', 'Dedicated First Class lounge'] },
  ],
  routesHeading: 'Popular Lufthansa Routes',
  routesSubheading: 'Frequently booked Lufthansa routes — call us for the best available fare.',
  routes: [
    { from: 'New York (JFK)', to: 'Frankfurt (FRA)', duration: '7h 55m', tag: 'International' },
    { from: 'Chicago (ORD)', to: 'Munich (MUC)', duration: '8h 50m', tag: 'International' },
    { from: 'Washington (IAD)', to: 'Frankfurt (FRA)', duration: '7h 40m', tag: 'Popular' },
    { from: 'Los Angeles (LAX)', to: 'Frankfurt (FRA)', duration: '11h 05m', tag: 'International' },
    { from: 'Frankfurt (FRA)', to: 'Munich (MUC)', duration: '1h 05m', tag: 'Deal' },
    { from: 'Boston (BOS)', to: 'Frankfurt (FRA)', duration: '7h 20m', tag: 'International' },
    { from: 'Frankfurt (FRA)', to: 'Rome (FCO)', duration: '1h 55m', tag: 'International' },
    { from: 'Atlanta (ATL)', to: 'Frankfurt (FRA)', duration: '9h 30m', tag: 'Business' },
  ],
  ctaHeading: 'Ready to Book Your Lufthansa Flight?',
  ctaDesc: 'Our travel experts are available 24/7 to find you the best Lufthansa fares, help with seat upgrades, and assist with any changes or cancellations.',
  faqs: [
    { q: 'How do I book Lufthansa flights through TheAirlineFares?', a: `You can book online at theairlinefares.com or call our 24/7 support line at ${TFN}. Our agents search all available Lufthansa fares to find you the best price.` },
    { q: 'What is Lufthansa Miles & More?', a: 'Miles & More is Lufthansa\'s frequent flyer program, one of the largest in Europe. Members earn miles on Lufthansa Group and Star Alliance flights redeemable for award tickets and upgrades.' },
    { q: 'What cabin classes does Lufthansa offer?', a: 'Lufthansa offers Economy, Premium Economy, Business Class with lie-flat seating, and an exclusive First Class experience on select long-haul routes.' },
    { q: 'Can I change or cancel my Lufthansa ticket?', a: `Change and cancellation options depend on fare type. Call us at ${TFN} and we will walk you through your options.` },
    { q: 'What are Lufthansa\'s main hubs?', a: 'Lufthansa\'s primary hubs are Frankfurt (FRA) and Munich (MUC), offering connections across Europe, Africa, Asia, and the Americas.' },
  ],
  seoTitle: 'Lufthansa Flights – Book Cheap LH Tickets',
  seoDescription: 'Book Lufthansa (LH) flights at the lowest fares. Compare Economy, Premium Economy, Business, and First Class tickets. 24/7 expert support — call +1 (888) 778-8606.',
  seoKeywords: 'Lufthansa flights, LH flights, Lufthansa booking, cheap Lufthansa tickets, Miles & More, Lufthansa business class, Lufthansa deals, book Lufthansa flights',
  disclaimerName: 'Lufthansa',
};

export const BRITISH_AIRWAYS = {
  code: 'BA',
  name: 'British Airways',
  canonical: '/ba/airlines',
  tag: 'Oneworld Founding Member',
  heroGradient: 'from-blue-950 via-blue-900 to-slate-800',
  accentClass: 'text-red-300',
  statColor: 'text-blue-800',
  hubBoxGradient: 'from-blue-900 to-red-800',
  ctaGradient: 'from-blue-900 to-red-700',
  logo: { src: '/british-airways-logo.svg', alt: 'British Airways logo' },
  h1First: 'British Airways Flights',
  h1Second: 'Book at the Best Price',
  subtitle: 'World Traveller to First Class · Global Oneworld Network · 24/7 Expert Support',
  originAirport: 'JFK',
  destinationAirport: 'LHR',
  stats: [
    { value: '1974', label: 'Founded' },
    { value: '280+', label: 'Aircraft' },
    { value: '180+', label: 'Destinations' },
    { value: 'Oneworld', label: 'Global Network' },
  ],
  aboutParagraphs: [
    "British Airways is the United Kingdom's flag carrier and a founding member of the <strong>Oneworld</strong> alliance. Operating primarily from <strong>London Heathrow (LHR)</strong>, one of the world's busiest international hubs, BA connects travelers to over 180 destinations across six continents.",
    "Known for its iconic Speedmarque tailfin livery and Concorde heritage, British Airways today operates a modern long-haul fleet including the Airbus A350 and Boeing 787, with a widely regarded <strong>Club World</strong> lie-flat business cabin on transatlantic routes.",
  ],
  aboutBullets: [
    'Oneworld founding member with global alliance connectivity',
    'Hub at London Heathrow with strong Terminal 5 connections',
    'Club World lie-flat business class on long-haul routes',
    'Executive Club loyalty program with Avios rewards currency',
    'Extensive codeshare network with American Airlines via the transatlantic joint business',
  ],
  hubs: [
    { code: 'LHR', name: 'London Heathrow' },
    { code: 'LGW', name: 'London Gatwick' },
    { code: 'JFK', name: 'New York JFK' },
    { code: 'ORD', name: 'Chicago O\'Hare' },
    { code: 'LAX', name: 'Los Angeles' },
    { code: 'BOS', name: 'Boston Logan' },
  ],
  cabinsHeading: 'British Airways Cabin Classes',
  cabinsSubheading: 'From World Traveller to First — find the right seat for your journey to the UK and beyond.',
  cabins: [
    { name: 'World Traveller', icon: '💺', color: 'border-blue-200 bg-blue-50', badge: 'bg-blue-100 text-blue-800', features: ['Standard seat pitch', 'In-flight entertainment', 'Complimentary meal & drinks', 'Carry-on bag included'] },
    { name: 'World Traveller Plus', icon: '🪑', color: 'border-slate-200 bg-slate-50', badge: 'bg-slate-100 text-slate-800', features: ['Extra legroom & recline', 'Dedicated cabin & check-in', 'Enhanced dining service', 'Priority boarding'] },
    { name: 'Club World', icon: '⭐', color: 'border-red-200 bg-red-50', badge: 'bg-red-100 text-red-800', features: ['Lie-flat seating (long-haul)', 'Executive Lounge access', 'Priority check-in & boarding', 'Two free checked bags'] },
    { name: 'First', icon: '🌟', color: 'border-amber-200 bg-amber-50', badge: 'bg-amber-100 text-amber-800', features: ['Private suite-style seating', 'Concorde Room lounge (LHR)', 'Dedicated cabin crew service', 'Chauffeur transfer on select fares'] },
  ],
  routesHeading: 'Popular British Airways Routes',
  routesSubheading: 'Frequently booked British Airways routes — call us for the best available fare.',
  routes: [
    { from: 'New York (JFK)', to: 'London (LHR)', duration: '7h 05m', tag: 'International' },
    { from: 'Chicago (ORD)', to: 'London (LHR)', duration: '8h 10m', tag: 'Popular' },
    { from: 'Los Angeles (LAX)', to: 'London (LHR)', duration: '10h 30m', tag: 'International' },
    { from: 'Boston (BOS)', to: 'London (LHR)', duration: '6h 40m', tag: 'International' },
    { from: 'London (LHR)', to: 'Paris (CDG)', duration: '1h 25m', tag: 'Deal' },
    { from: 'Miami (MIA)', to: 'London (LHR)', duration: '9h 05m', tag: 'Vacation' },
    { from: 'London (LHR)', to: 'Dubai (DXB)', duration: '7h 15m', tag: 'Business' },
    { from: 'Washington (IAD)', to: 'London (LHR)', duration: '7h 20m', tag: 'International' },
  ],
  ctaHeading: 'Ready to Book Your British Airways Flight?',
  ctaDesc: 'Our travel experts are available 24/7 to find you the best British Airways fares, help with seat upgrades, and assist with any changes or cancellations.',
  faqs: [
    { q: 'How do I book British Airways flights through TheAirlineFares?', a: `You can book online at theairlinefares.com or call our 24/7 support line at ${TFN}. Our agents search all available British Airways fares to find you the best price.` },
    { q: 'What is British Airways Executive Club?', a: 'Executive Club is BA\'s frequent flyer program. Members earn Avios, a flexible rewards currency redeemable for flights, upgrades, and partner rewards across Oneworld.' },
    { q: 'What cabin classes does British Airways offer?', a: 'British Airways offers World Traveller (Economy), World Traveller Plus (Premium Economy), Club World (Business), and First on select long-haul routes.' },
    { q: 'Can I change or cancel my British Airways ticket?', a: `Change and cancellation rules depend on fare type. Call us at ${TFN} and we will walk you through your options at no extra service charge.` },
    { q: 'What is British Airways\' main hub?', a: 'British Airways is primarily based at London Heathrow (LHR), with a secondary base at London Gatwick (LGW) for select leisure routes.' },
  ],
  seoTitle: 'British Airways Flights – Book Cheap BA Tickets',
  seoDescription: 'Book British Airways (BA) flights at the lowest fares. Compare World Traveller, Club World, and First Class tickets. 24/7 expert support — call +1 (888) 778-8606.',
  seoKeywords: 'British Airways flights, BA flights, British Airways booking, cheap British Airways tickets, Club World, Executive Club Avios, book British Airways flights',
  disclaimerName: 'British Airways',
};

export const SWISS = {
  code: 'LX',
  name: 'Swiss International Air Lines',
  canonical: '/lx/airlines',
  tag: 'Star Alliance Member',
  heroGradient: 'from-red-950 via-red-900 to-rose-800',
  accentClass: 'text-white',
  statColor: 'text-red-700',
  hubBoxGradient: 'from-red-900 to-rose-700',
  ctaGradient: 'from-red-900 to-rose-700',
  logo: { src: '/swiss-logo.svg', alt: 'Swiss International Air Lines logo' },
  h1First: 'Swiss Flights',
  h1Second: 'Book at the Best Price',
  subtitle: 'Economy to First Class · Star Alliance Network via Zurich · 24/7 Expert Support',
  originAirport: 'JFK',
  destinationAirport: 'ZRH',
  stats: [
    { value: '2002', label: 'Founded' },
    { value: '90+', label: 'Aircraft' },
    { value: '100+', label: 'Destinations' },
    { value: 'Star Alliance', label: 'Global Network' },
  ],
  aboutParagraphs: [
    "Swiss International Air Lines is Switzerland's flag carrier, part of the Lufthansa Group, and a member of the <strong>Star Alliance</strong>. Operating from its hub at <strong>Zurich Airport (ZRH)</strong>, with a secondary base in Geneva, Swiss connects travelers to over 100 destinations worldwide.",
    "Renowned for Swiss precision and hospitality, the airline offers a distinctive dining experience inspired by Swiss cuisine and operates a modern long-haul fleet including the Boeing 777-300ER and Airbus A340, alongside a fully lie-flat <strong>Business Class</strong>.",
  ],
  aboutBullets: [
    'Star Alliance member with Lufthansa Group connectivity',
    'Zurich hub known for fast, efficient connections',
    'Swiss-inspired onboard dining and hospitality',
    'Miles & More loyalty program shared with Lufthansa Group',
    'Modern long-haul fleet with lie-flat Business Class seating',
  ],
  hubs: [
    { code: 'ZRH', name: 'Zurich' },
    { code: 'GVA', name: 'Geneva' },
    { code: 'JFK', name: 'New York JFK' },
    { code: 'ORD', name: 'Chicago O\'Hare' },
    { code: 'LAX', name: 'Los Angeles' },
    { code: 'BOS', name: 'Boston Logan' },
  ],
  cabinsHeading: 'Swiss Cabin Classes',
  cabinsSubheading: 'From Economy to First — find the right seat for your journey to Switzerland and beyond.',
  cabins: [
    { name: 'Economy', icon: '💺', color: 'border-red-200 bg-red-50', badge: 'bg-red-100 text-red-800', features: ['Standard seat pitch', 'Swiss-inspired meal service', 'In-seat entertainment', 'Carry-on bag included'] },
    { name: 'Premium Economy', icon: '🪑', color: 'border-rose-200 bg-rose-50', badge: 'bg-rose-100 text-rose-800', features: ['Extra legroom & recline', 'Dedicated check-in', 'Enhanced dining', 'Priority baggage handling'] },
    { name: 'Business', icon: '⭐', color: 'border-gray-300 bg-gray-50', badge: 'bg-gray-200 text-gray-800', features: ['Lie-flat seating on long-haul', 'SWISS lounge access in Zurich', 'Priority boarding', 'Two free checked bags'] },
    { name: 'First', icon: '🌟', color: 'border-amber-200 bg-amber-50', badge: 'bg-amber-100 text-amber-800', features: ['Private First Class cabin', 'Exclusive First lounge & terrace (ZRH)', 'Chauffeur transfer service', 'Multi-course fine dining'] },
  ],
  routesHeading: 'Popular Swiss Routes',
  routesSubheading: 'Frequently booked Swiss International Air Lines routes — call us for the best available fare.',
  routes: [
    { from: 'New York (JFK)', to: 'Zurich (ZRH)', duration: '8h 05m', tag: 'International' },
    { from: 'Chicago (ORD)', to: 'Zurich (ZRH)', duration: '8h 50m', tag: 'Popular' },
    { from: 'Los Angeles (LAX)', to: 'Zurich (ZRH)', duration: '11h 15m', tag: 'International' },
    { from: 'Boston (BOS)', to: 'Zurich (ZRH)', duration: '7h 25m', tag: 'International' },
    { from: 'Zurich (ZRH)', to: 'Geneva (GVA)', duration: '0h 50m', tag: 'Deal' },
    { from: 'Miami (MIA)', to: 'Zurich (ZRH)', duration: '9h 40m', tag: 'Vacation' },
    { from: 'Zurich (ZRH)', to: 'Milan (MXP)', duration: '1h 05m', tag: 'International' },
    { from: 'San Francisco (SFO)', to: 'Zurich (ZRH)', duration: '11h 30m', tag: 'Business' },
  ],
  ctaHeading: 'Ready to Book Your Swiss Flight?',
  ctaDesc: 'Our travel experts are available 24/7 to find you the best Swiss International Air Lines fares, help with seat upgrades, and assist with any changes or cancellations.',
  faqs: [
    { q: 'How do I book Swiss flights through TheAirlineFares?', a: `You can book online at theairlinefares.com or call our 24/7 support line at ${TFN}. Our agents search all available Swiss fares to find you the best price.` },
    { q: 'What loyalty program does Swiss use?', a: 'Swiss participates in Miles & More, the Lufthansa Group\'s shared frequent flyer program, redeemable for flights and upgrades across Star Alliance.' },
    { q: 'What cabin classes does Swiss offer?', a: 'Swiss offers Economy, Premium Economy, Business Class with lie-flat seating, and an exclusive First Class cabin on select long-haul aircraft.' },
    { q: 'Can I change or cancel my Swiss ticket?', a: `Change and cancellation options depend on fare type. Call us at ${TFN} and we will walk you through your options.` },
    { q: 'What is Swiss\' main hub?', a: 'Swiss International Air Lines is based at Zurich Airport (ZRH), with a secondary hub in Geneva (GVA).' },
  ],
  seoTitle: 'Swiss Air Lines Flights – Book Cheap LX Tickets',
  seoDescription: 'Book Swiss International Air Lines (LX) flights at the lowest fares. Compare Economy, Business, and First Class tickets to Zurich. 24/7 expert support — call +1 (888) 778-8606.',
  seoKeywords: 'Swiss Air flights, LX flights, Swiss International Air Lines booking, cheap Swiss Air tickets, Zurich flights, Swiss business class, book Swiss flights',
  disclaimerName: 'Swiss International Air Lines',
};

export const CATHAY_PACIFIC = {
  code: 'CX',
  name: 'Cathay Pacific',
  canonical: '/cx/airlines',
  tag: 'Oneworld Member',
  heroGradient: 'from-emerald-950 via-green-900 to-teal-800',
  accentClass: 'text-emerald-300',
  statColor: 'text-emerald-700',
  hubBoxGradient: 'from-emerald-900 to-teal-700',
  ctaGradient: 'from-emerald-900 to-teal-700',
  logo: { src: '/cathay-pacific-logo.svg', alt: 'Cathay Pacific logo' },
  h1First: 'Cathay Pacific Flights',
  h1Second: 'Book at the Best Price',
  subtitle: 'Economy to First Class · Gateway to Asia via Hong Kong · 24/7 Expert Support',
  originAirport: 'LAX',
  destinationAirport: 'HKG',
  stats: [
    { value: '1946', label: 'Founded' },
    { value: '150+', label: 'Aircraft' },
    { value: '80+', label: 'Destinations' },
    { value: 'Oneworld', label: 'Global Network' },
  ],
  aboutParagraphs: [
    "Cathay Pacific is Hong Kong's home carrier and a member of the <strong>Oneworld</strong> alliance, operating from its hub at <strong>Hong Kong International Airport (HKG)</strong>. The airline is one of the leading gateways between North America and Asia, connecting to over 80 destinations.",
    "Cathay Pacific is consistently ranked among the world's top airlines for its award-winning <strong>Business</strong> and <strong>First Class</strong> cabins, signature lounges in Hong Kong, and its distinctive brushwing livery reflecting the airline's Asian heritage.",
  ],
  aboutBullets: [
    'Oneworld member with extensive Asia-Pacific connectivity',
    'Major hub at Hong Kong International Airport',
    'Award-winning First and Business Class cabins',
    'Asia Miles loyalty program with Marco Polo Club status tiers',
    'Modern long-haul fleet including Airbus A350 and Boeing 777',
  ],
  hubs: [
    { code: 'HKG', name: 'Hong Kong' },
    { code: 'LAX', name: 'Los Angeles' },
    { code: 'JFK', name: 'New York JFK' },
    { code: 'SFO', name: 'San Francisco' },
    { code: 'ORD', name: 'Chicago O\'Hare' },
    { code: 'YVR', name: 'Vancouver' },
  ],
  cabinsHeading: 'Cathay Pacific Cabin Classes',
  cabinsSubheading: 'From Economy to First — find the right seat for your journey to Asia and beyond.',
  cabins: [
    { name: 'Economy', icon: '💺', color: 'border-emerald-200 bg-emerald-50', badge: 'bg-emerald-100 text-emerald-800', features: ['Standard seat pitch', 'Multi-course meal service', 'Studio in-flight entertainment', 'Carry-on bag included'] },
    { name: 'Premium Economy', icon: '🪑', color: 'border-teal-200 bg-teal-50', badge: 'bg-teal-100 text-teal-800', features: ['Extra legroom & recline', 'Dedicated check-in', 'Enhanced dining', 'Priority baggage handling'] },
    { name: 'Business', icon: '⭐', color: 'border-green-200 bg-green-50', badge: 'bg-green-100 text-green-800', features: ['Lie-flat seating on long-haul', 'The Pier / The Wing lounges (HKG)', 'Priority boarding', 'Two free checked bags'] },
    { name: 'First', icon: '🌟', color: 'border-amber-200 bg-amber-50', badge: 'bg-amber-100 text-amber-800', features: ['Private suite-style seating', 'The Pier First lounge access', 'Personal butler-style service', 'Multi-course fine dining'] },
  ],
  routesHeading: 'Popular Cathay Pacific Routes',
  routesSubheading: 'Frequently booked Cathay Pacific routes — call us for the best available fare.',
  routes: [
    { from: 'Los Angeles (LAX)', to: 'Hong Kong (HKG)', duration: '15h 10m', tag: 'International' },
    { from: 'New York (JFK)', to: 'Hong Kong (HKG)', duration: '16h 05m', tag: 'Popular' },
    { from: 'San Francisco (SFO)', to: 'Hong Kong (HKG)', duration: '14h 40m', tag: 'International' },
    { from: 'Chicago (ORD)', to: 'Hong Kong (HKG)', duration: '15h 55m', tag: 'International' },
    { from: 'Hong Kong (HKG)', to: 'Tokyo (NRT)', duration: '4h 10m', tag: 'Deal' },
    { from: 'Vancouver (YVR)', to: 'Hong Kong (HKG)', duration: '13h 45m', tag: 'Vacation' },
    { from: 'Hong Kong (HKG)', to: 'Singapore (SIN)', duration: '3h 55m', tag: 'International' },
    { from: 'Hong Kong (HKG)', to: 'Bangkok (BKK)', duration: '2h 50m', tag: 'Business' },
  ],
  ctaHeading: 'Ready to Book Your Cathay Pacific Flight?',
  ctaDesc: 'Our travel experts are available 24/7 to find you the best Cathay Pacific fares, help with seat upgrades, and assist with any changes or cancellations.',
  faqs: [
    { q: 'How do I book Cathay Pacific flights through TheAirlineFares?', a: `You can book online at theairlinefares.com or call our 24/7 support line at ${TFN}. Our agents search all available Cathay Pacific fares to find you the best price.` },
    { q: 'What is Cathay Pacific Asia Miles?', a: 'Asia Miles is Cathay Pacific\'s frequent flyer currency, while Marco Polo Club manages elite status. Members earn miles redeemable for flights, upgrades, and partner rewards.' },
    { q: 'What cabin classes does Cathay Pacific offer?', a: 'Cathay Pacific offers Economy, Premium Economy, Business Class with lie-flat seating, and an award-winning First Class on select long-haul routes.' },
    { q: 'Can I change or cancel my Cathay Pacific ticket?', a: `Change and cancellation rules depend on fare type. Call us at ${TFN} and we will walk you through your options at no extra service charge.` },
    { q: 'What is Cathay Pacific\'s main hub?', a: 'Cathay Pacific is based at Hong Kong International Airport (HKG), a major gateway connecting North America to Asia-Pacific destinations.' },
  ],
  seoTitle: 'Cathay Pacific Flights – Book Cheap CX Tickets',
  seoDescription: 'Book Cathay Pacific (CX) flights at the lowest fares. Compare Economy, Premium Economy, Business, and First Class tickets to Hong Kong. 24/7 expert support — call +1 (888) 778-8606.',
  seoKeywords: 'Cathay Pacific flights, CX flights, Cathay Pacific booking, cheap Cathay Pacific tickets, Hong Kong flights, Asia Miles, book Cathay Pacific flights',
  disclaimerName: 'Cathay Pacific',
};

export const TAP_PORTUGAL = {
  code: 'TP',
  name: 'TAP Air Portugal',
  canonical: '/tp/airlines',
  tag: 'Star Alliance Member',
  heroGradient: 'from-rose-950 via-red-900 to-rose-800',
  accentClass: 'text-rose-200',
  statColor: 'text-rose-700',
  hubBoxGradient: 'from-rose-900 to-red-800',
  ctaGradient: 'from-rose-900 to-red-700',
  logo: { src: '/tap-air-portugal-logo.svg', alt: 'TAP Air Portugal logo' },
  h1First: 'TAP Air Portugal Flights',
  h1Second: 'Book at the Best Price',
  subtitle: 'Economy to Business · Gateway to Portugal & Beyond · 24/7 Expert Support',
  originAirport: 'BOS',
  destinationAirport: 'LIS',
  stats: [
    { value: '1945', label: 'Founded' },
    { value: '90+', label: 'Aircraft' },
    { value: '90+', label: 'Destinations' },
    { value: 'Star Alliance', label: 'Global Network' },
  ],
  aboutParagraphs: [
    "TAP Air Portugal is Portugal's flag carrier and a member of the <strong>Star Alliance</strong>, operating from its hub at <strong>Lisbon Airport (LIS)</strong>. TAP is a key link between North America, Europe, Africa, and Brazil, thanks to Lisbon's convenient geographic position.",
    "With one of the largest US-to-Portugal networks of any carrier, TAP is especially popular out of Boston, a city with deep Portuguese-American ties. The airline operates a modern Airbus A320neo and A330neo fleet and offers a lie-flat <strong>Business Class</strong> on long-haul routes.",
  ],
  aboutBullets: [
    'Star Alliance member connecting Europe, Africa, and the Americas',
    'Lisbon hub ideal for free stopovers en route to Europe or Africa',
    'Strong US network with deep roots in the Boston market',
    'TAP Miles&Go loyalty program for frequent flyers',
    'Modern Airbus A330neo fleet with lie-flat Business Class',
  ],
  hubs: [
    { code: 'LIS', name: 'Lisbon' },
    { code: 'OPO', name: 'Porto' },
    { code: 'BOS', name: 'Boston Logan' },
    { code: 'JFK', name: 'New York JFK' },
    { code: 'EWR', name: 'Newark' },
    { code: 'MIA', name: 'Miami' },
  ],
  cabinsHeading: 'TAP Air Portugal Cabin Classes',
  cabinsSubheading: 'From Economy to Business — find the right fare for your journey to Portugal and beyond.',
  cabins: [
    { name: 'Economy Discount', icon: '💺', color: 'border-rose-200 bg-rose-50', badge: 'bg-rose-100 text-rose-800', features: ['Lowest base fare', 'Carry-on bag included', 'Seat assignment at check-in', 'Basic in-flight service'] },
    { name: 'Economy Classic', icon: '🎒', color: 'border-red-200 bg-red-50', badge: 'bg-red-100 text-red-800', features: ['Checked bag included', 'Advance seat selection', 'Standard meal service', 'Changeable with fee'] },
    { name: 'Economy Premium', icon: '🪑', color: 'border-pink-200 bg-pink-50', badge: 'bg-pink-100 text-pink-800', features: ['Extra legroom seating', 'Priority boarding', 'Enhanced meal service', 'Two checked bags'] },
    { name: 'Business', icon: '⭐', color: 'border-amber-200 bg-amber-50', badge: 'bg-amber-100 text-amber-800', features: ['Lie-flat seating on long-haul', 'TAP lounge access in Lisbon', 'Priority check-in & boarding', 'Premium dining service'] },
  ],
  routesHeading: 'Popular TAP Air Portugal Routes',
  routesSubheading: 'Frequently booked TAP routes — call us for the best available fare.',
  routes: [
    { from: 'Boston (BOS)', to: 'Lisbon (LIS)', duration: '6h 30m', tag: 'Popular' },
    { from: 'New York (JFK)', to: 'Lisbon (LIS)', duration: '6h 50m', tag: 'International' },
    { from: 'Newark (EWR)', to: 'Lisbon (LIS)', duration: '6h 45m', tag: 'International' },
    { from: 'Miami (MIA)', to: 'Lisbon (LIS)', duration: '8h 30m', tag: 'International' },
    { from: 'Lisbon (LIS)', to: 'Porto (OPO)', duration: '0h 55m', tag: 'Deal' },
    { from: 'Lisbon (LIS)', to: 'Paris (CDG)', duration: '2h 30m', tag: 'International' },
    { from: 'Lisbon (LIS)', to: 'São Paulo (GRU)', duration: '9h 20m', tag: 'Vacation' },
    { from: 'San Francisco (SFO)', to: 'Lisbon (LIS)', duration: '12h 15m', tag: 'Business' },
  ],
  ctaHeading: 'Ready to Book Your TAP Air Portugal Flight?',
  ctaDesc: 'Our travel experts are available 24/7 to find you the best TAP Air Portugal fares, help with seat upgrades, and assist with any changes or cancellations.',
  faqs: [
    { q: 'How do I book TAP Air Portugal flights through TheAirlineFares?', a: `You can book online at theairlinefares.com or call our 24/7 support line at ${TFN}. Our agents search all available TAP fares to find you the best price.` },
    { q: 'What is TAP Miles&Go?', a: 'Miles&Go is TAP Air Portugal\'s frequent flyer program. Members earn miles redeemable for flights, upgrades, and rewards across Star Alliance.' },
    { q: 'What cabin classes does TAP Air Portugal offer?', a: 'TAP offers Economy Discount, Economy Classic, Economy Premium (extra legroom), and a lie-flat Business Class on long-haul routes.' },
    { q: 'Can I change or cancel my TAP ticket?', a: `Change and cancellation rules depend on fare type. Call us at ${TFN} and we will walk you through your options at no extra service charge.` },
    { q: 'What is TAP\'s main hub?', a: 'TAP Air Portugal is based at Lisbon Airport (LIS), a popular connecting point between the Americas, Europe, and Africa.' },
  ],
  seoTitle: 'TAP Air Portugal Flights – Book Cheap TP Tickets',
  seoDescription: 'Book TAP Air Portugal (TP) flights at the lowest fares. Compare Economy and Business Class tickets to Lisbon and beyond. 24/7 expert support — call +1 (888) 778-8606.',
  seoKeywords: 'TAP Air Portugal flights, TP flights, TAP booking, cheap TAP tickets, Lisbon flights, TAP Miles&Go, book TAP Air Portugal flights',
  disclaimerName: 'TAP Air Portugal',
};

export const KLM = {
  code: 'KL',
  name: 'KLM Royal Dutch Airlines',
  canonical: '/kl/airlines',
  tag: 'SkyTeam Founding Member',
  heroGradient: 'from-cyan-950 via-blue-900 to-cyan-800',
  accentClass: 'text-cyan-300',
  statColor: 'text-cyan-700',
  hubBoxGradient: 'from-cyan-900 to-blue-800',
  ctaGradient: 'from-cyan-900 to-blue-700',
  logo: { src: '/klm-logo.svg', alt: 'KLM Royal Dutch Airlines logo' },
  h1First: 'KLM Flights',
  h1Second: 'Book at the Best Price',
  subtitle: 'Economy to Business Class · SkyTeam Network via Amsterdam · 24/7 Expert Support',
  originAirport: 'JFK',
  destinationAirport: 'AMS',
  stats: [
    { value: '1919', label: 'Founded' },
    { value: '110+', label: 'Aircraft' },
    { value: '145+', label: 'Destinations' },
    { value: 'SkyTeam', label: 'Global Network' },
  ],
  aboutParagraphs: [
    "KLM Royal Dutch Airlines is the world's oldest airline still operating under its original name, founded in 1919. A founding member of the <strong>SkyTeam</strong> alliance, KLM operates from its hub at <strong>Amsterdam Schiphol Airport (AMS)</strong>, connecting to over 145 destinations worldwide.",
    "Together with Air France under the Air France-KLM Group, KLM offers extensive transatlantic and Europe-Asia connectivity. The airline is known for its Delft Blue houses gifted in World Business Class and its modern long-haul fleet including the Boeing 787 and 777.",
  ],
  aboutBullets: [
    'SkyTeam founding member with global alliance connectivity',
    'Amsterdam Schiphol hub with efficient single-terminal transfers',
    'Flying Blue loyalty program shared with Air France',
    'Iconic Delft Blue houses served in World Business Class',
    'Modern long-haul fleet including Boeing 787 Dreamliner',
  ],
  hubs: [
    { code: 'AMS', name: 'Amsterdam Schiphol' },
    { code: 'JFK', name: 'New York JFK' },
    { code: 'ATL', name: 'Atlanta' },
    { code: 'BOS', name: 'Boston Logan' },
    { code: 'ORD', name: 'Chicago O\'Hare' },
    { code: 'SFO', name: 'San Francisco' },
  ],
  cabinsHeading: 'KLM Cabin Classes',
  cabinsSubheading: 'From Economy to World Business Class — find the right seat for your journey to Amsterdam and beyond.',
  cabins: [
    { name: 'Economy', icon: '💺', color: 'border-cyan-200 bg-cyan-50', badge: 'bg-cyan-100 text-cyan-800', features: ['Standard seat pitch', 'Complimentary meal service', 'In-seat entertainment', 'Carry-on bag included'] },
    { name: 'Premium Comfort', icon: '🪑', color: 'border-blue-200 bg-blue-50', badge: 'bg-blue-100 text-blue-800', features: ['Extra legroom & recline', 'Dedicated check-in', 'Enhanced dining', 'Priority baggage handling'] },
    { name: 'World Business Class', icon: '⭐', color: 'border-sky-200 bg-sky-50', badge: 'bg-sky-100 text-sky-800', features: ['Lie-flat seating on long-haul', 'KLM Crown Lounge access', 'Priority boarding', 'Delft Blue house gift'] },
  ],
  routesHeading: 'Popular KLM Routes',
  routesSubheading: 'Frequently booked KLM routes — call us for the best available fare.',
  routes: [
    { from: 'New York (JFK)', to: 'Amsterdam (AMS)', duration: '7h 45m', tag: 'International' },
    { from: 'Atlanta (ATL)', to: 'Amsterdam (AMS)', duration: '9h 10m', tag: 'Popular' },
    { from: 'Boston (BOS)', to: 'Amsterdam (AMS)', duration: '6h 55m', tag: 'International' },
    { from: 'San Francisco (SFO)', to: 'Amsterdam (AMS)', duration: '10h 40m', tag: 'International' },
    { from: 'Amsterdam (AMS)', to: 'Paris (CDG)', duration: '1h 15m', tag: 'Deal' },
    { from: 'Chicago (ORD)', to: 'Amsterdam (AMS)', duration: '8h 35m', tag: 'International' },
    { from: 'Amsterdam (AMS)', to: 'Bali (DPS)', duration: '16h 30m', tag: 'Vacation' },
    { from: 'Detroit (DTW)', to: 'Amsterdam (AMS)', duration: '8h 05m', tag: 'Business' },
  ],
  ctaHeading: 'Ready to Book Your KLM Flight?',
  ctaDesc: 'Our travel experts are available 24/7 to find you the best KLM fares, help with seat upgrades, and assist with any changes or cancellations.',
  faqs: [
    { q: 'How do I book KLM flights through TheAirlineFares?', a: `You can book online at theairlinefares.com or call our 24/7 support line at ${TFN}. Our agents search all available KLM fares to find you the best price.` },
    { q: 'What is KLM Flying Blue?', a: 'Flying Blue is the shared frequent flyer program of KLM and Air France. Members earn miles redeemable for flights, upgrades, and rewards across SkyTeam.' },
    { q: 'What cabin classes does KLM offer?', a: 'KLM offers Economy, Premium Comfort (extra legroom), and a lie-flat World Business Class on long-haul routes.' },
    { q: 'Can I change or cancel my KLM ticket?', a: `Change and cancellation rules depend on fare type. Call us at ${TFN} and we will walk you through your options at no extra service charge.` },
    { q: 'What is KLM\'s main hub?', a: 'KLM operates from Amsterdam Schiphol Airport (AMS), known for efficient single-terminal international connections.' },
  ],
  seoTitle: 'KLM Flights – Book Cheap KL Tickets',
  seoDescription: 'Book KLM Royal Dutch Airlines (KL) flights at the lowest fares. Compare Economy, Premium Comfort, and World Business Class tickets. 24/7 expert support — call +1 (888) 778-8606.',
  seoKeywords: 'KLM flights, KL flights, KLM booking, cheap KLM tickets, Amsterdam flights, Flying Blue, KLM business class, book KLM flights',
  disclaimerName: 'KLM Royal Dutch Airlines',
};

export const AIR_FRANCE = {
  code: 'AF',
  name: 'Air France',
  canonical: '/af/airlines',
  tag: 'SkyTeam Founding Member',
  heroGradient: 'from-blue-950 via-indigo-900 to-blue-800',
  accentClass: 'text-red-300',
  statColor: 'text-blue-800',
  hubBoxGradient: 'from-blue-900 to-indigo-800',
  ctaGradient: 'from-blue-900 to-red-700',
  logo: { src: '/air-france-logo.svg', alt: 'Air France logo' },
  h1First: 'Air France Flights',
  h1Second: 'Book at the Best Price',
  subtitle: 'Economy to La Première · SkyTeam Network via Paris · 24/7 Expert Support',
  originAirport: 'JFK',
  destinationAirport: 'CDG',
  stats: [
    { value: '1933', label: 'Founded' },
    { value: '200+', label: 'Aircraft' },
    { value: '190+', label: 'Destinations' },
    { value: 'SkyTeam', label: 'Global Network' },
  ],
  aboutParagraphs: [
    "Air France is France's flag carrier and a founding member of the <strong>SkyTeam</strong> alliance, operating from its hub at <strong>Paris Charles de Gaulle Airport (CDG)</strong>. Together with KLM under the Air France-KLM Group, it forms one of the largest airline networks connecting the Americas, Europe, Africa, and Asia.",
    "Air France is known for its distinctly French approach to hospitality, offering gourmet dining curated by renowned chefs and its ultra-premium <strong>La Première</strong> first class cabin — one of the few first class products still offered on transatlantic routes.",
  ],
  aboutBullets: [
    'SkyTeam founding member with extensive global connectivity',
    'Major hub at Paris Charles de Gaulle with strong Africa network',
    'La Première — an exclusive first class cabin with private suites',
    'Flying Blue loyalty program shared with KLM',
    'Gourmet in-flight dining curated by French chefs',
  ],
  hubs: [
    { code: 'CDG', name: 'Paris Charles de Gaulle' },
    { code: 'JFK', name: 'New York JFK' },
    { code: 'ATL', name: 'Atlanta' },
    { code: 'BOS', name: 'Boston Logan' },
    { code: 'IAD', name: 'Washington Dulles' },
    { code: 'LAX', name: 'Los Angeles' },
  ],
  cabinsHeading: 'Air France Cabin Classes',
  cabinsSubheading: 'From Economy to La Première — find the right seat for your journey to Paris and beyond.',
  cabins: [
    { name: 'Economy', icon: '💺', color: 'border-blue-200 bg-blue-50', badge: 'bg-blue-100 text-blue-800', features: ['Standard seat pitch', 'French-inspired meal service', 'In-seat entertainment', 'Carry-on bag included'] },
    { name: 'Premium Economy', icon: '🪑', color: 'border-indigo-200 bg-indigo-50', badge: 'bg-indigo-100 text-indigo-800', features: ['Extra legroom & recline', 'Dedicated check-in', 'Enhanced dining', 'Priority baggage handling'] },
    { name: 'Business', icon: '⭐', color: 'border-red-200 bg-red-50', badge: 'bg-red-100 text-red-800', features: ['Lie-flat seating on long-haul', 'Air France lounge access (CDG)', 'Priority boarding', 'Gourmet dining service'] },
    { name: 'La Première', icon: '🌟', color: 'border-amber-200 bg-amber-50', badge: 'bg-amber-100 text-amber-800', features: ['Private suite with sliding door', 'La Première lounge & salon (CDG)', 'Chauffeur transfer service', 'Multi-course fine dining'] },
  ],
  routesHeading: 'Popular Air France Routes',
  routesSubheading: 'Frequently booked Air France routes — call us for the best available fare.',
  routes: [
    { from: 'New York (JFK)', to: 'Paris (CDG)', duration: '7h 30m', tag: 'International' },
    { from: 'Atlanta (ATL)', to: 'Paris (CDG)', duration: '9h 05m', tag: 'Popular' },
    { from: 'Washington (IAD)', to: 'Paris (CDG)', duration: '7h 40m', tag: 'International' },
    { from: 'Los Angeles (LAX)', to: 'Paris (CDG)', duration: '11h 10m', tag: 'International' },
    { from: 'Paris (CDG)', to: 'Nice (NCE)', duration: '1h 25m', tag: 'Deal' },
    { from: 'Boston (BOS)', to: 'Paris (CDG)', duration: '7h 00m', tag: 'International' },
    { from: 'Paris (CDG)', to: 'Marrakech (RAK)', duration: '3h 15m', tag: 'Vacation' },
    { from: 'Miami (MIA)', to: 'Paris (CDG)', duration: '9h 20m', tag: 'Business' },
  ],
  ctaHeading: 'Ready to Book Your Air France Flight?',
  ctaDesc: 'Our travel experts are available 24/7 to find you the best Air France fares, help with seat upgrades, and assist with any changes or cancellations.',
  faqs: [
    { q: 'How do I book Air France flights through TheAirlineFares?', a: `You can book online at theairlinefares.com or call our 24/7 support line at ${TFN}. Our agents search all available Air France fares to find you the best price.` },
    { q: 'What is Air France Flying Blue?', a: 'Flying Blue is the shared frequent flyer program of Air France and KLM. Members earn miles redeemable for flights, upgrades, and rewards across SkyTeam.' },
    { q: 'What cabin classes does Air France offer?', a: 'Air France offers Economy, Premium Economy, Business Class, and the ultra-premium La Première first class on select long-haul routes.' },
    { q: 'Can I change or cancel my Air France ticket?', a: `Change and cancellation rules depend on fare type. Call us at ${TFN} and we will walk you through your options at no extra service charge.` },
    { q: 'What is Air France\'s main hub?', a: 'Air France operates from Paris Charles de Gaulle Airport (CDG), a major connecting point between the Americas, Europe, and Africa.' },
  ],
  seoTitle: 'Air France Flights – Book Cheap AF Tickets',
  seoDescription: 'Book Air France (AF) flights at the lowest fares. Compare Economy, Premium Economy, Business, and La Première tickets. 24/7 expert support — call +1 (888) 778-8606.',
  seoKeywords: 'Air France flights, AF flights, Air France booking, cheap Air France tickets, Paris flights, Flying Blue, La Premiere, book Air France flights',
  disclaimerName: 'Air France',
};

export const ITA_AIRWAYS = {
  code: 'AZ',
  name: 'ITA Airways',
  canonical: '/az/airlines',
  tag: 'SkyTeam Member',
  heroGradient: 'from-green-950 via-emerald-900 to-teal-700',
  accentClass: 'text-emerald-300',
  statColor: 'text-green-700',
  hubBoxGradient: 'from-green-900 to-teal-700',
  ctaGradient: 'from-green-900 to-emerald-700',
  logo: { src: '/ita-airways-logo.svg', alt: 'ITA Airways logo' },
  h1First: 'ITA Airways Flights',
  h1Second: 'Book at the Best Price',
  subtitle: 'Economy to Business Class · Gateway to Italy via Rome · 24/7 Expert Support',
  originAirport: 'JFK',
  destinationAirport: 'FCO',
  stats: [
    { value: '2021', label: 'Founded' },
    { value: '60+', label: 'Aircraft' },
    { value: '45+', label: 'Destinations' },
    { value: 'SkyTeam', label: 'Global Network' },
  ],
  aboutParagraphs: [
    "ITA Airways is Italy's flag carrier, launched in 2021 as the successor to Alitalia, and operates from its hub at <strong>Rome Fiumicino Airport (FCO)</strong>. The airline joined the <strong>SkyTeam</strong> alliance, expanding its global connectivity through partner carriers.",
    "ITA Airways emphasizes Italian design and craftsmanship throughout the customer experience, from cabin interiors to onboard dining featuring regional Italian cuisine, and operates a fleet of modern Airbus A220, A320, and A330 aircraft.",
  ],
  aboutBullets: [
    'SkyTeam member with growing global alliance connectivity',
    'Rome Fiumicino hub for connections across Italy and the Mediterranean',
    'Italian-designed cabins and regional in-flight dining',
    'Volare loyalty program for frequent flyers',
    'Modern fleet including Airbus A220 and A330neo aircraft',
  ],
  hubs: [
    { code: 'FCO', name: 'Rome Fiumicino' },
    { code: 'MXP', name: 'Milan Malpensa' },
    { code: 'JFK', name: 'New York JFK' },
    { code: 'BOS', name: 'Boston Logan' },
    { code: 'MIA', name: 'Miami' },
    { code: 'ORD', name: 'Chicago O\'Hare' },
  ],
  cabinsHeading: 'ITA Airways Cabin Classes',
  cabinsSubheading: 'From Economy to Business — find the right seat for your journey to Italy and beyond.',
  cabins: [
    { name: 'Economy', icon: '💺', color: 'border-green-200 bg-green-50', badge: 'bg-green-100 text-green-800', features: ['Standard seat pitch', 'Italian-inspired meal service', 'In-seat entertainment', 'Carry-on bag included'] },
    { name: 'Premium Economy', icon: '🪑', color: 'border-emerald-200 bg-emerald-50', badge: 'bg-emerald-100 text-emerald-800', features: ['Extra legroom & recline', 'Dedicated check-in', 'Enhanced dining', 'Priority baggage handling'] },
    { name: 'Business', icon: '⭐', color: 'border-teal-200 bg-teal-50', badge: 'bg-teal-100 text-teal-800', features: ['Lie-flat seating on long-haul', 'ITA lounge access in Rome', 'Priority boarding', 'Regional Italian fine dining'] },
  ],
  routesHeading: 'Popular ITA Airways Routes',
  routesSubheading: 'Frequently booked ITA Airways routes — call us for the best available fare.',
  routes: [
    { from: 'New York (JFK)', to: 'Rome (FCO)', duration: '8h 55m', tag: 'International' },
    { from: 'Boston (BOS)', to: 'Rome (FCO)', duration: '8h 20m', tag: 'Popular' },
    { from: 'Miami (MIA)', to: 'Rome (FCO)', duration: '9h 45m', tag: 'International' },
    { from: 'Chicago (ORD)', to: 'Rome (FCO)', duration: '9h 30m', tag: 'International' },
    { from: 'Rome (FCO)', to: 'Milan (MXP)', duration: '1h 15m', tag: 'Deal' },
    { from: 'Rome (FCO)', to: 'Athens (ATH)', duration: '1h 50m', tag: 'International' },
    { from: 'Rome (FCO)', to: 'São Paulo (GRU)', duration: '11h 10m', tag: 'Vacation' },
    { from: 'Los Angeles (LAX)', to: 'Rome (FCO)', duration: '12h 30m', tag: 'Business' },
  ],
  ctaHeading: 'Ready to Book Your ITA Airways Flight?',
  ctaDesc: 'Our travel experts are available 24/7 to find you the best ITA Airways fares, help with seat upgrades, and assist with any changes or cancellations.',
  faqs: [
    { q: 'How do I book ITA Airways flights through TheAirlineFares?', a: `You can book online at theairlinefares.com or call our 24/7 support line at ${TFN}. Our agents search all available ITA Airways fares to find you the best price.` },
    { q: 'What is ITA Airways Volare?', a: 'Volare is ITA Airways\' frequent flyer program. Members earn miles redeemable for flights, upgrades, and rewards across SkyTeam partner airlines.' },
    { q: 'What cabin classes does ITA Airways offer?', a: 'ITA Airways offers Economy, Premium Economy, and a lie-flat Business Class on long-haul routes.' },
    { q: 'Can I change or cancel my ITA Airways ticket?', a: `Change and cancellation rules depend on fare type. Call us at ${TFN} and we will walk you through your options at no extra service charge.` },
    { q: 'What is ITA Airways\' main hub?', a: 'ITA Airways is based at Rome Fiumicino Airport (FCO), with a secondary hub at Milan Malpensa (MXP).' },
  ],
  seoTitle: 'ITA Airways Flights – Book Cheap AZ Tickets',
  seoDescription: 'Book ITA Airways (AZ) flights at the lowest fares. Compare Economy, Premium Economy, and Business Class tickets to Rome and beyond. 24/7 expert support — call +1 (888) 778-8606.',
  seoKeywords: 'ITA Airways flights, AZ flights, ITA Airways booking, cheap ITA Airways tickets, Rome flights, Volare loyalty, book ITA Airways flights',
  disclaimerName: 'ITA Airways',
};

export const AMERICAN_AIRLINES = {
  code: 'AA',
  name: 'American Airlines',
  canonical: '/aa/airlines',
  tag: 'Oneworld Founding Member',
  heroGradient: 'from-slate-900 via-blue-900 to-red-900',
  accentClass: 'text-red-300',
  statColor: 'text-blue-800',
  hubBoxGradient: 'from-blue-900 to-slate-800',
  ctaGradient: 'from-blue-900 to-red-800',
  logo: { src: '/american-airlines-logo.png', alt: 'American Airlines logo', width: 80, height: 80 },
  h1First: 'American Airlines Flights',
  h1Second: 'Book at the Best Price',
  subtitle: 'Main Cabin to Flagship First · Largest US Domestic Network · 24/7 Expert Support',
  originAirport: 'DFW',
  destinationAirport: 'LAX',
  stats: [
    { value: '1926', label: 'Founded' },
    { value: '900+', label: 'Aircraft' },
    { value: '350+', label: 'Destinations' },
    { value: 'Oneworld', label: 'Global Network' },
  ],
  aboutParagraphs: [
    "American Airlines is the world's largest airline by fleet size and a founding member of the <strong>Oneworld</strong> alliance. Operating from its primary hub at <strong>Dallas/Fort Worth (DFW)</strong>, alongside major hubs in Charlotte, Chicago, Miami, and Phoenix, American connects travelers to over 350 destinations.",
    "American is known for its extensive US domestic network, its <strong>AAdvantage</strong> frequent flyer program — one of the oldest and largest in the industry — and its premium <strong>Flagship Business</strong> and <strong>Flagship First</strong> cabins on select long-haul and transcontinental routes.",
  ],
  aboutBullets: [
    'Largest US domestic network by destinations served',
    'Oneworld founding member with global alliance benefits',
    'AAdvantage — one of the industry\'s longest-running loyalty programs',
    'Flagship Business and Flagship First on select premium routes',
    'Multiple major hubs including DFW, Charlotte, and Chicago O\'Hare',
  ],
  hubs: [
    { code: 'DFW', name: 'Dallas/Fort Worth' },
    { code: 'CLT', name: 'Charlotte' },
    { code: 'ORD', name: "Chicago O'Hare" },
    { code: 'MIA', name: 'Miami' },
    { code: 'PHX', name: 'Phoenix' },
    { code: 'PHL', name: 'Philadelphia' },
  ],
  cabinsHeading: 'American Airlines Cabin Classes',
  cabinsSubheading: 'From Main Cabin to Flagship First — find the right seat for your journey.',
  cabins: [
    { name: 'Main Cabin', icon: '💺', color: 'border-blue-200 bg-blue-50', badge: 'bg-blue-100 text-blue-800', features: ['Standard seat pitch', 'Carry-on bag included', 'In-flight entertainment', 'Buy-on-board snacks & meals'] },
    { name: 'Premium Economy', icon: '🪑', color: 'border-slate-200 bg-slate-50', badge: 'bg-slate-100 text-slate-800', features: ['Extra legroom & recline', 'Priority boarding', 'Enhanced meal service', 'Two free checked bags'] },
    { name: 'Flagship Business', icon: '⭐', color: 'border-red-200 bg-red-50', badge: 'bg-red-100 text-red-800', features: ['Lie-flat seating on long-haul', 'Flagship Lounge access', 'Priority check-in & boarding', 'Premium dining service'] },
    { name: 'Flagship First', icon: '🌟', color: 'border-amber-200 bg-amber-50', badge: 'bg-amber-100 text-amber-800', features: ['Spacious suite-style seating', 'Flagship First Dining (select cities)', 'Dedicated check-in', 'Chauffeur transfer on select routes'] },
  ],
  routesHeading: 'Popular American Airlines Routes',
  routesSubheading: 'Frequently booked American Airlines routes — call us for the best available fare.',
  routes: [
    { from: 'Dallas (DFW)', to: 'Los Angeles (LAX)', duration: '3h 15m', tag: 'Popular' },
    { from: 'Charlotte (CLT)', to: 'Miami (MIA)', duration: '2h 10m', tag: 'Popular' },
    { from: 'Chicago (ORD)', to: 'Phoenix (PHX)', duration: '3h 40m', tag: 'Deal' },
    { from: 'Philadelphia (PHL)', to: 'London (LHR)', duration: '7h 30m', tag: 'International' },
    { from: 'Dallas (DFW)', to: 'Cancun (CUN)', duration: '2h 05m', tag: 'Vacation' },
    { from: 'Miami (MIA)', to: 'New York (JFK)', duration: '2h 55m', tag: 'Business' },
    { from: 'Los Angeles (LAX)', to: 'Sydney (SYD)', duration: '15h 30m', tag: 'International' },
    { from: 'Chicago (ORD)', to: 'Dallas (DFW)', duration: '2h 20m', tag: 'Popular' },
  ],
  ctaHeading: 'Ready to Book Your American Airlines Flight?',
  ctaDesc: 'Our travel experts are available 24/7 to find you the best American Airlines fares, help with seat upgrades, and assist with any changes or cancellations.',
  faqs: [
    { q: 'How do I book American Airlines flights through TheAirlineFares?', a: `You can book online at theairlinefares.com or call our 24/7 support line at ${TFN}. Our agents search all available American fares to find you the best price.` },
    { q: 'What is American Airlines AAdvantage?', a: 'AAdvantage is American Airlines\' frequent flyer program. Members earn miles redeemable for flights, upgrades, and rewards across Oneworld partner airlines.' },
    { q: 'What cabin classes does American Airlines offer?', a: 'American offers Main Cabin, Premium Economy, Flagship Business, and Flagship First on select transcontinental and international routes.' },
    { q: 'Can I change or cancel my American Airlines ticket?', a: `American allows free changes on most fare types. Basic Economy fares may have restrictions. Call us at ${TFN} and we will walk you through your options at no extra charge.` },
    { q: 'What are American Airlines\' main hubs?', a: 'American\'s major hubs include Dallas/Fort Worth (DFW), Charlotte (CLT), Chicago O\'Hare (ORD), Miami (MIA), Phoenix (PHX), and Philadelphia (PHL).' },
  ],
  seoTitle: 'American Airlines Flights – Book Cheap AA Tickets',
  seoDescription: 'Book American Airlines (AA) flights at the lowest fares. Compare Main Cabin, Premium Economy, Flagship Business, and First Class tickets. 24/7 expert support — call +1 (888) 778-8606.',
  seoKeywords: 'American Airlines flights, AA flights, American Airlines booking, cheap American Airlines tickets, AAdvantage, Flagship Business, book American Airlines flights',
  disclaimerName: 'American Airlines',
};

export const DELTA_AIR_LINES = {
  code: 'DL',
  name: 'Delta Air Lines',
  canonical: '/dl/airlines',
  tag: 'SkyTeam Founding Member',
  heroGradient: 'from-blue-950 via-slate-900 to-red-900',
  accentClass: 'text-red-300',
  statColor: 'text-blue-800',
  hubBoxGradient: 'from-blue-900 to-red-800',
  ctaGradient: 'from-blue-900 to-red-700',
  logo: { src: '/delta-air-lines-logo.png', alt: 'Delta Air Lines logo', width: 80, height: 80 },
  h1First: 'Delta Air Lines Flights',
  h1Second: 'Book at the Best Price',
  subtitle: 'Main Cabin to Delta One · Industry-Leading Reliability · 24/7 Expert Support',
  originAirport: 'ATL',
  destinationAirport: 'JFK',
  stats: [
    { value: '1924', label: 'Founded' },
    { value: '850+', label: 'Aircraft' },
    { value: '300+', label: 'Destinations' },
    { value: 'SkyTeam', label: 'Global Network' },
  ],
  aboutParagraphs: [
    "Delta Air Lines is one of the world's largest airlines and a founding member of the <strong>SkyTeam</strong> alliance. Operating from its primary hub at <strong>Hartsfield-Jackson Atlanta International Airport (ATL)</strong> — the world's busiest airport — Delta connects travelers to over 300 destinations across six continents.",
    "Delta is consistently ranked among the most reliable US carriers for on-time performance and is known for its <strong>SkyMiles</strong> frequent flyer program and its premium <strong>Delta One</strong> suites, offering lie-flat seating and elevated service on long-haul and select transcontinental routes.",
  ],
  aboutBullets: [
    'Industry-leading on-time performance and operational reliability',
    'SkyTeam founding member with extensive global connectivity',
    'SkyMiles — a top-rated frequent flyer program with no award expiration',
    'Delta One lie-flat suites on international and premium transcontinental routes',
    'Major hubs across Atlanta, Detroit, Minneapolis-St. Paul, and Salt Lake City',
  ],
  hubs: [
    { code: 'ATL', name: 'Atlanta Hartsfield-Jackson' },
    { code: 'DTW', name: 'Detroit Metro' },
    { code: 'MSP', name: 'Minneapolis-St. Paul' },
    { code: 'JFK', name: 'New York JFK' },
    { code: 'LAX', name: 'Los Angeles' },
    { code: 'SLC', name: 'Salt Lake City' },
  ],
  cabinsHeading: 'Delta Air Lines Cabin Classes',
  cabinsSubheading: 'From Main Cabin to Delta One — find the right seat for your journey.',
  cabins: [
    { name: 'Main Cabin', icon: '💺', color: 'border-blue-200 bg-blue-50', badge: 'bg-blue-100 text-blue-800', features: ['Standard seat pitch', 'Carry-on bag included', 'Free in-flight entertainment', 'Complimentary snacks & drinks'] },
    { name: 'Delta Comfort+', icon: '🪑', color: 'border-slate-200 bg-slate-50', badge: 'bg-slate-100 text-slate-800', features: ['Extra legroom & recline', 'Priority boarding', 'Dedicated overhead bin space', 'Premium snacks on select flights'] },
    { name: 'Premium Select', icon: '⭐', color: 'border-red-200 bg-red-50', badge: 'bg-red-100 text-red-800', features: ['Wider seats with more recline', 'Amenity kit on long-haul flights', 'Enhanced dining service', 'Priority check-in & boarding'] },
    { name: 'Delta One', icon: '🌟', color: 'border-amber-200 bg-amber-50', badge: 'bg-amber-100 text-amber-800', features: ['Lie-flat suites on long-haul routes', 'Delta Sky Club lounge access', 'Chef-curated multi-course dining', 'Dedicated check-in & priority baggage'] },
  ],
  routesHeading: 'Popular Delta Air Lines Routes',
  routesSubheading: 'Frequently booked Delta routes — call us for the best available fare.',
  routes: [
    { from: 'Atlanta (ATL)', to: 'Los Angeles (LAX)', duration: '4h 40m', tag: 'Popular' },
    { from: 'Atlanta (ATL)', to: 'New York (JFK)', duration: '2h 10m', tag: 'Popular' },
    { from: 'Detroit (DTW)', to: 'Paris (CDG)', duration: '8h 15m', tag: 'International' },
    { from: 'Minneapolis (MSP)', to: 'Amsterdam (AMS)', duration: '8h 30m', tag: 'International' },
    { from: 'New York (JFK)', to: 'Los Angeles (LAX)', duration: '6h 15m', tag: 'Business' },
    { from: 'Atlanta (ATL)', to: 'London (LHR)', duration: '8h 55m', tag: 'International' },
    { from: 'Salt Lake City (SLC)', to: 'Seattle (SEA)', duration: '2h 05m', tag: 'Deal' },
    { from: 'Atlanta (ATL)', to: 'Cancun (CUN)', duration: '2h 15m', tag: 'Vacation' },
  ],
  ctaHeading: 'Ready to Book Your Delta Air Lines Flight?',
  ctaDesc: 'Our travel experts are available 24/7 to find you the best Delta fares, help with seat upgrades, and assist with any changes or cancellations.',
  faqs: [
    { q: 'How do I book Delta Air Lines flights through TheAirlineFares?', a: `You can book online at theairlinefares.com or call our 24/7 support line at ${TFN}. Our agents search all available Delta fares to find you the best price.` },
    { q: 'What is Delta SkyMiles?', a: 'SkyMiles is Delta\'s frequent flyer program. Miles never expire and can be redeemed for flights, upgrades, Delta One suites, and rewards across SkyTeam partner airlines.' },
    { q: 'What cabin classes does Delta Air Lines offer?', a: 'Delta offers Main Cabin, Delta Comfort+ (extra legroom), Premium Select, and Delta One lie-flat suites on international and premium transcontinental routes.' },
    { q: 'Can I change or cancel my Delta ticket?', a: `Delta allows free changes on most fare types, with Basic Economy carrying some restrictions. Call us at ${TFN} and we will walk you through your options at no extra charge.` },
    { q: 'What are Delta Air Lines\' main hubs?', a: 'Delta\'s major hubs include Atlanta (ATL), Detroit (DTW), Minneapolis-St. Paul (MSP), Salt Lake City (SLC), New York JFK/LGA, and Los Angeles (LAX).' },
  ],
  seoTitle: 'Delta Air Lines Flights – Book Cheap DL Tickets',
  seoDescription: 'Book Delta Air Lines (DL) flights at the lowest fares. Compare Main Cabin, Comfort+, Premium Select, and Delta One tickets. 24/7 expert support — call +1 (888) 778-8606.',
  seoKeywords: 'Delta Air Lines flights, DL flights, Delta booking, cheap Delta tickets, SkyMiles, Delta One, Delta Comfort+, book Delta flights',
  disclaimerName: 'Delta Air Lines',
};

export const JETBLUE_AIRWAYS = {
  code: 'B6',
  name: 'JetBlue Airways',
  canonical: '/b6/airlines',
  tag: 'Low-Cost Carrier',
  heroGradient: 'from-blue-950 via-sky-900 to-cyan-800',
  accentClass: 'text-cyan-300',
  statColor: 'text-blue-700',
  hubBoxGradient: 'from-blue-900 to-cyan-700',
  ctaGradient: 'from-blue-900 to-cyan-700',
  logo: { src: '/jetblue-logo.png', alt: 'JetBlue Airways logo', width: 90, height: 90 },
  h1First: 'JetBlue Airways Flights',
  h1Second: 'Book at the Best Price',
  subtitle: 'Blue Basic to Mint Suites · Free Wi-Fi & Extra Legroom · 24/7 Expert Support',
  originAirport: 'JFK',
  destinationAirport: 'MCO',
  stats: [
    { value: '1998', label: 'Founded' },
    { value: '290+', label: 'Aircraft' },
    { value: '100+', label: 'Destinations' },
    { value: 'TrueBlue', label: 'Rewards Program' },
  ],
  aboutParagraphs: [
    "JetBlue Airways is a leading low-cost carrier based at <strong>New York's John F. Kennedy International Airport (JFK)</strong>, with additional focus cities in Boston, Fort Lauderdale, Orlando, and San Juan. JetBlue connects travelers to over 100 destinations across the US, Caribbean, and Latin America, with growing transatlantic service to Europe.",
    "Known for reinventing the flying experience, JetBlue offers free high-speed Wi-Fi and free seatback entertainment on every flight, along with more legroom in economy than most US carriers. Its premium <strong>Mint</strong> cabin features lie-flat suites on select transcontinental and international routes.",
  ],
  aboutBullets: [
    'Free high-speed Wi-Fi and free seatback entertainment on every flight',
    'More legroom in Core economy than most other US airlines',
    'Mint lie-flat suites on transcontinental and select international routes',
    'TrueBlue loyalty program with points that never expire',
    'Growing transatlantic network from New York and Boston to Europe',
  ],
  hubs: [
    { code: 'JFK', name: 'New York JFK' },
    { code: 'BOS', name: 'Boston Logan' },
    { code: 'FLL', name: 'Fort Lauderdale' },
    { code: 'MCO', name: 'Orlando' },
    { code: 'SJU', name: 'San Juan' },
    { code: 'LAX', name: 'Los Angeles' },
  ],
  cabinsHeading: 'JetBlue Airways Cabin Classes',
  cabinsSubheading: 'From Blue Basic to Mint — find the right fare and seat for your journey.',
  cabins: [
    { name: 'Blue Basic', icon: '🎒', color: 'border-sky-200 bg-sky-50', badge: 'bg-sky-100 text-sky-800', features: ['Lowest base fare', 'Free Wi-Fi & seatback TV', 'Personal item included', 'Changeable with fee'] },
    { name: 'Core', icon: '💺', color: 'border-blue-200 bg-blue-50', badge: 'bg-blue-100 text-blue-800', features: ['Carry-on & checked bag included', 'Free high-speed Wi-Fi', 'Free live TV & entertainment', 'Standard seat pitch'] },
    { name: 'Even More Space', icon: '🪑', color: 'border-cyan-200 bg-cyan-50', badge: 'bg-cyan-100 text-cyan-800', features: ['Up to 5" extra legroom', 'Early boarding', 'Preferred cabin location', 'Free Wi-Fi & entertainment'] },
    { name: 'Mint', icon: '🌟', color: 'border-amber-200 bg-amber-50', badge: 'bg-amber-100 text-amber-800', features: ['Lie-flat suites (select routes)', 'Elevated dining & amenity kit', 'Priority boarding & bags', 'Free Wi-Fi & entertainment'] },
  ],
  routesHeading: 'Popular JetBlue Airways Routes',
  routesSubheading: 'Frequently booked JetBlue routes — call us for the best available fare.',
  routes: [
    { from: 'New York (JFK)', to: 'Fort Lauderdale (FLL)', duration: '3h 05m', tag: 'Popular' },
    { from: 'New York (JFK)', to: 'Orlando (MCO)', duration: '2h 55m', tag: 'Popular' },
    { from: 'Boston (BOS)', to: 'Fort Lauderdale (FLL)', duration: '3h 20m', tag: 'Deal' },
    { from: 'New York (JFK)', to: 'Los Angeles (LAX)', duration: '6h 10m', tag: 'Business' },
    { from: 'New York (JFK)', to: 'London (LHR)', duration: '7h 15m', tag: 'International' },
    { from: 'Boston (BOS)', to: 'San Juan (SJU)', duration: '3h 55m', tag: 'Vacation' },
    { from: 'New York (JFK)', to: 'Cancun (CUN)', duration: '3h 55m', tag: 'Vacation' },
    { from: 'Fort Lauderdale (FLL)', to: 'San Juan (SJU)', duration: '2h 20m', tag: 'International' },
  ],
  ctaHeading: 'Ready to Book Your JetBlue Flight?',
  ctaDesc: 'Our travel experts are available 24/7 to find you the best JetBlue fares, help with seat selection, and assist with any changes or cancellations.',
  faqs: [
    { q: 'How do I book JetBlue Airways flights through TheAirlineFares?', a: `You can book online at theairlinefares.com or call our 24/7 support line at ${TFN}. Our agents search all available JetBlue fares to find you the best price.` },
    { q: 'What is JetBlue TrueBlue?', a: 'TrueBlue is JetBlue\'s frequent flyer program. Points never expire and can be redeemed for flights, seat upgrades, and Mint suites with no blackout dates.' },
    { q: 'What cabin classes does JetBlue offer?', a: 'JetBlue offers Blue Basic, Core, Even More Space (extra legroom), and Mint lie-flat suites on transcontinental and select international routes.' },
    { q: 'Can I change or cancel my JetBlue ticket?', a: `JetBlue allows free changes on most fare types; Blue Basic fares may carry a change fee. Call us at ${TFN} and we will walk you through your options at no extra charge.` },
    { q: 'What are JetBlue\'s main focus cities?', a: 'JetBlue\'s primary base is New York JFK, with major focus cities in Boston (BOS), Fort Lauderdale (FLL), Orlando (MCO), and San Juan (SJU).' },
  ],
  seoTitle: 'JetBlue Airways Flights – Book Cheap B6 Tickets',
  seoDescription: 'Book JetBlue Airways (B6) flights at the lowest fares. Compare Blue Basic, Core, Even More Space, and Mint tickets. 24/7 expert support — call +1 (888) 778-8606.',
  seoKeywords: 'JetBlue flights, B6 flights, JetBlue booking, cheap JetBlue tickets, TrueBlue, JetBlue Mint, book JetBlue flights',
  disclaimerName: 'JetBlue Airways',
};

export const AIRLINES_LIST = [
  ICELANDAIR, LUFTHANSA, BRITISH_AIRWAYS, SWISS, CATHAY_PACIFIC,
  TAP_PORTUGAL, KLM, AIR_FRANCE, ITA_AIRWAYS, AMERICAN_AIRLINES,
  DELTA_AIR_LINES, JETBLUE_AIRWAYS,
];
